import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import { downloadFile } from '@/api/manage';
import moment from 'moment';
export default {
  name: 'waterData',
  data: function data() {
    return {
      options: [],
      moment: moment,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      limitSelectDate: {},
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        align: 'center'
      },
      queryParam: {},
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 150,
        dataIndex: 'dataTime',
        colName: 'data_time'
      }],
      loading: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.id = ids[1];
        this.queryParam.type = '1';
        this.loadData();
      } else {
        this.queryParam.id = ids[1];
        this.queryParam.type = '2';
        this.loadData();
      }
    }
  },
  created: function created() {
    this.queryParam.stime = moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');
  },
  methods: {
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
      this.loadData();
    },
    handleExportXls: function handleExportXls(s) {
      downloadFile(s, "/st53/cn2011/export", this.queryParam);
    },
    onDateOk: function onDateOk(value) {
      console.log(value);
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },
    // 查询
    searchQuery: function searchQuery() {
      this.loadData();
    },
    // 列变化
    onChange: function onChange(checkedValues) {
      var _this = this;

      this.columns = _toConsumableArray(this.cols);
      checkedValues.forEach(function (item, i) {
        _this.allColumns.forEach(function (element) {
          if (item == element.id) {
            _this.columns.push(element);
          }
        });
      });
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    },
    // 水质标准
    renderStatus: function renderStatus(record) {
      var h = this.$createElement;

      if (record.currentStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.currentStandard.color
        }, [record.currentStandard.title]);
      } else {
        return '';
      }
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.loadData();
    },
    // 加载表格
    loadData: function loadData(arg) {
      var _this2 = this;

      this.loading = true;
      var that = this;
      this.queryParam.factorCategory = 11;
      this.queryParam.current = this.ipagination.current;
      this.queryParam.size = this.ipagination.pageSize;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      getAction('/st53/cn2011', this.queryParam).then(function (res) {
        if (res.success) {
          that.dataSource = res.result.records;
          that.ipagination.total = res.result.total;
          that.allColumns = _toConsumableArray(that.cols);
          that.selectCol = [];
          that.options = [];

          if (res.result.factorMap['11']) {
            res.result.factorMap['11'].forEach(function (element) {
              that.options.push({
                label: element.title,
                value: element.id
              });
              that.selectCol.push(element.id);
              that.allColumns.push({
                id: element.id,
                title: element.title,
                align: 'center',
                width: 250,
                children: [{
                  title: element.unitName,
                  align: 'center',
                  width: 200,
                  dataIndex: element.code,
                  customRender: function customRender(text, record, index) {
                    return that.renderCol(element.code, text, record);
                  }
                }]
              });
            });
          }

          that.columns = _toConsumableArray(that.allColumns);

          if (that.queryParam.type == '1') {
            that.spliceColumn(that.siteColumn);
          } else if (that.queryParam.type == '2') {
            that.spliceColumn(that.siteColumn, 1);
          }
        } else {
          _this2.$message.warning('系统异常=>' + res.message);
        }

        _this2.loading = false;
      });
    }
  }
};